export default "__VITE_ASSET__40b5ac64__"